import { CountryNames } from '@/enums/general'
import { addLocalCurrency, getImagePaths } from '@/utils/general'

import { Orientations } from '@/enums/products'

export const invoiceMixin = {
  data () {
    return {
      invoice: {
        countryCode: 'nl',
        member: {
          id: 23986,
          firstname: 'George',
          lastname: 'Clooney',
          fullName: 'George Clooney',
          phoneNumber: '06123456789',
          email: 'g.clooney@gmail.com',
          status: 'Active',
          dateOfBirth: 519224461,
          billingAddress: {
            streetType: '',
            building: '',
            floor: '',
            street: 'Graafsebaan',
            houseNumber: 135,
            annex: '',
            postalCode: '5248NL',
            city: 'Rosmalen',
            region: '',
            country: 'Nederland'
          }
        },
        orderBundle: {
          total: 9.99,
          vat: 1.67,
          subtotal: 8.32,
          discount: 9.99,
          paymentNumber: '3779623',
          currencyCode: 'EUR',
          orderDate: '2020-06-01 00:00:00',
          orders: [{
            type: 'Men Originals',
            product: 'SAVAGE',
            size: 'XL',
            quantity: 1,
            price: 9.99
          }, {
            type: 'Men One',
            product: 'SAVAGE',
            size: 'XL',
            quantity: 1,
            price: 9.99
          }]
        }
      }
    }
  },

  methods: {
    convertToLocaleCurrency (value, code) {
      return addLocalCurrency(value, code, this.invoice.orderBundle.currencyCode)
    },
    async downloadInvoice () {
      const pdfMake = (await import('pdfmake/build/pdfmake')).default
      const pdfFonts = (await import('pdfmake/build/vfs_fonts')).default

      pdfMake.vfs = pdfFonts.pdfMake.vfs

      const invoiceStyles = {
        // Document Footer
        documentFooterCenter: {
          margin: [5, 5, 5, 5],
          fontSize: 8,
          alignment: 'center'
        },
        invoiceBlock: {
          fillColor: 'black',
          margin: [5, 10, 5, 10],
          color: 'white'
        },
        invoiceBlockLarge: {
          margin: [0, 5, 0, 0],
          fontSize: 16
        },
        // Billing Headers
        invoiceBillingTitle: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        // Billing Details
        invoiceBillingDetails: {
          margin: [5, 20, 5, 20],
          fillColor: '#F0F0F0',
          lineHeight: 1.3
        },
        // Items Header
        itemsHeader: {
          margin: [5, 5, 5, 5],
          bold: true,
          color: '#989898'
        },
        itemsContent: {
          fillColor: '#F0F0F0',
          margin: [5, 10, 5, 10]
        },
        // Items Footer (Subtotal, Total, Tax, etc)
        itemsFooterSubTitle: {
          margin: [5, 5, 15, 5],
          color: '#989898'
        },
        itemsFooterSubValue: {
          margin: [5, 5, 5, 5],
          color: '#989898'
        },
        itemsFooterTotalTitle: {
          margin: [5, 5, 15, 5],
          bold: true
        },
        itemsFooterTotalValue: {
          margin: [5, 5, 5, 5],
          bold: true
        },
        center: {
          alignment: 'center'
        },
        right: {
          alignment: 'right'
        },
        red: {
          color: 'red'
        }
      }

      const bodyData = []
      // Table header
      bodyData.push(
        [
          {
            text: ' '
          },
          {
            text: this.$t('Invoice.Amount', { locale: this.invoice.countryCode }),
            style: ['itemsHeader', 'center']
          },
          {
            text: this.$t('Invoice.Description', { locale: this.invoice.countryCode }),
            style: 'itemsHeader'
          },
          {
            text: this.$t('Invoice.PiecePrice', { locale: this.invoice.countryCode }),
            style: 'itemsHeader'
          },
          {
            text: this.$t('Invoice.Total', { locale: this.invoice.countryCode }),
            style: 'itemsHeader'
          },
          {
            text: ' '
          }
        ]
      )
      // Table rows
      const self = this
      this.invoice.orderBundle.orders.forEach((item) => {
        const dataRow = []
        dataRow.push(
          {
            text: ' ',
            style: 'itemsContent'
          },
          {
            text: item.quantity,
            style: ['itemsContent', 'center']
          },
          {
            text: item.product + ' | ' + item.type + ' ' + item.size,
            style: 'itemsContent'
          },
          {
            text: self.convertToLocaleCurrency(item.price, this.invoice.countryCode),
            style: 'itemsContent'
          },
          {
            text: self.convertToLocaleCurrency(item.price, this.invoice.countryCode),
            style: 'itemsContent'
          }, {
            text: ' ',
            style: 'itemsContent'
          }
        )
        bodyData.push(dataRow)
      })

      // Discount
      if (this.invoice.orderBundle.discount > 0) {
        const discountRow = []

        discountRow.push(
          {
            text: ' ',
            style: 'itemsContent'
          },
          {
            text: 1,
            style: ['itemsContent', 'center']
          },
          {
            text: this.$t('Invoice.Discount', { locale: this.invoice.countryCode }),
            style: 'itemsContent'
          },
          {
            text: '- ' + self.convertToLocaleCurrency(this.invoice.orderBundle.discount, this.invoice.countryCode),
            style: ['itemsContent', 'red']
          },
          {
            text: '- ' + self.convertToLocaleCurrency(this.invoice.orderBundle.discount, this.invoice.countryCode),
            style: ['itemsContent', 'red']
          }, {
            text: ' ',
            style: 'itemsContent'
          }
        )

        bodyData.push(discountRow)
      }

      const invoiceContent = [
        {
          columns: [
            {
              image: 'data:image/png;base64,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',
              style: 'center',
              margin: [0, 40, 0, 40]
            }
          ]
        },
        {
          columns: [
            {
              text: this.$t('Invoice.Invoice'),
              style: 'center',
              margin: [0, 10, 0, 20]
            }
          ]
        },
        {
          table: {
            headerRows: 0,
            widths: [40, '*', 10, '*', 10, '*', 40],
            body: [
              [
                {
                  text: ' '
                },
                {
                  stack: [
                    this.$t('Invoice.PaymentNumber', { locale: this.invoice.countryCode }) + '#',
                    {
                      text: this.invoice.orderBundle.paymentNumber,
                      style: 'invoiceBlockLarge'
                    }
                  ],
                  text: this.$t('Invoice.PaymentNumber') + '# \n' + this.invoice.orderBundle.paymentNumber,
                  style: 'invoiceBlock'
                },
                {
                  text: ' '
                },
                {
                  stack: [
                    this.$t('Invoice.Date', { locale: this.invoice.countryCode }),
                    {
                      text: this.$moment(this.invoice.orderBundle.orderDate).locale(this.invoice.countryCode).format('L'),
                      style: 'invoiceBlockLarge'
                    }
                  ],
                  style: 'invoiceBlock'
                },
                {
                  text: ' '
                },
                {
                  stack: [
                    this.$t('Invoice.TotalIncl', { locale: this.invoice.countryCode }),
                    {
                      text: this.convertToLocaleCurrency(this.invoice.orderBundle.total, this.invoice.countryCode),
                      style: 'invoiceBlockLarge'
                    }
                  ],
                  style: 'invoiceBlock'
                },
                {
                  text: ' '
                }
              ]
            ]
          },
          layout: 'noBorders'
        },
        '\n\n',
        {
          table: {
            headerRows: 0,
            widths: ['*', 140, 140, '*'],
            body: [
              [
                {
                  text: '',
                  style: 'invoiceBillingDetails'
                }, {
                  stack: [
                    {
                      text: 'ON THAT ASS',
                      style: ['invoiceBillingTitle', 'right']

                    }, {
                      text: 'Graafsebaan 135 A \n 5248NL Rosmalen \n ' + this.$t('Countries.nl') + ' \n \n 073 303 41 75 \n' + this.$t('Email', { locale: this.invoice.countryCode })
                    }
                  ],
                  style: ['invoiceBillingDetails', 'right']
                },
                {
                  stack: [
                    {
                      text: this.invoice.member.fullName,
                      style: 'invoiceBillingTitle'
                    },
                    {
                      text: this.invoice.member.billingAddress.street + ' ' + (this.invoice.member.billingAddress.houseNumber || '') + ' ' + (this.invoice.member.billingAddress.annex || '')
                    }, {
                      text: this.invoice.member.billingAddress.postalCode + ' ' + this.invoice.member.billingAddress.city
                    }, {
                      text: this.invoice.member.billingAddress.country
                    },
                    '\n',
                    {
                      text: this.invoice.member.phoneNumber
                    }, {
                      text: this.invoice.member.email
                    }
                  ],
                  style: 'invoiceBillingDetails'
                },
                {
                  text: '',
                  style: 'invoiceBillingDetails'
                }
              ]
            ]
          },
          layout: 'noBorders'
        },
        // Line breaks
        '\n\n',
        // Items
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [40, 60, '*', 70, 70, 40],
            body: bodyData
          },
          layout: 'noBorders'
        },
        // TOTAL
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 0,
            widths: ['*', 80, 40],

            body: [
              // Total
              [
                {
                  text: this.$t('Invoice.TotalExcl', { locale: this.invoice.countryCode }),
                  style: ['itemsFooterSubTitle', 'right']
                },
                {
                  text: this.convertToLocaleCurrency(this.invoice.orderBundle.subtotal, this.invoice.countryCode),
                  style: 'itemsFooterSubValue'
                },
                {
                  text: ' '
                }
              ],
              [
                {
                  text: this.$t('Invoice.Vat', { locale: this.invoice.countryCode }),
                  style: ['itemsFooterSubTitle', 'right']
                },
                {
                  text: this.convertToLocaleCurrency(this.invoice.orderBundle.vat, this.invoice.countryCode),
                  style: 'itemsFooterSubValue'
                },
                {
                  text: ' '
                }
              ],
              [
                {
                  text: this.$t('Invoice.Total', { locale: this.invoice.countryCode }),
                  style: ['itemsFooterTotalTitle', 'right']
                },
                {
                  text: this.convertToLocaleCurrency(this.invoice.orderBundle.total, this.invoice.countryCode),
                  style: 'itemsFooterTotalValue'
                },
                {
                  text: ' '
                }
              ]
            ]
          }, // table
          layout: 'noBorders'
        }
      ]
      const pdf = {
        content: invoiceContent,
        footer: {
          columns: [
            { text: 'KvK 64158969' + '      ' + 'BTW NL: NL855548095B01' + '      ' + 'BTW BE: BE0740885703' + '       onthatass.com', style: 'documentFooterCenter' }
          ]
        },
        styles: invoiceStyles,
        defaultStyle: {
          fontSize: 10,
          columnGap: 20
        },
        pageSize: 'A4',
        pageMargins: [0, 40, 0, 40]
      }
      pdfMake.createPdf(pdf).download('OTA-' + this.invoice.orderBundle.paymentNumber)
    },
    setInvoiceData (orderBundle) {
      const total = orderBundle.payment.amount
      const { _id: id, orders, payment } = orderBundle
      const { member } = orders.edges[0].node
      const vat = orders.edges[0].node.member.country.vat.value * 100
      const countryCode = member.country.name.toLowerCase()

      this.invoice.countryCode = countryCode

      this.invoice.orderBundle = {
        id,
        total,
        vat: parseFloat((total / (100 + vat) * vat).toFixed(2)),
        subtotal: parseFloat((total / (vat / 100 + 1)).toFixed(2)),
        discount: 0,
        paymentNumber: payment._id,
        currencyCode: payment.currencyIsoCode,
        orderDate: payment.debitDate,
        orders: orders.edges.map(order => ({
          type: order.node.product.productGroupSize.productGroup.name,
          product: order.node.product.name,
          size: order.node.product.productGroupSize.size.label,
          quantity: 1,
          price: order.node.amount
        }))
      }

      this.invoice.member = {
        firstname: member.firstName,
        lastname: member.lastName,
        fullName: member.fullName,
        phoneNumber: member.phoneNumber,
        email: member.email,
        billingAddress: {
          streetType: member.postalAddress.streetType,
          building: member.postalAddress.building,
          floor: member.postalAddress.floor,
          annex: member.postalAddress.annex,
          region: member.postalAddress.region,
          street: member.postalAddress.street,
          houseNumber: member.postalAddress.houseNumber,
          postalCode: member.postalAddress.postalCode,
          city: member.postalAddress.city,
          country: this.$t(CountryNames[countryCode])
        }
      }
    }
  }
}

export const getOrderBundleName = (orderBundle = {}) => orderBundle.orders?.edges[0]?.node?.product.design.name || ''

export const getOrderBundleReleaseDate = (orderBundle = {}) => orderBundle.orders?.edges[0]?.node?.product.design.release?.releaseDate || ''

export const extractProductImageSrc = (orderBundle = {}) => {
  const multiProductReferences = [Orientations.womenhipster, Orientations.womenbralette]
  const orderBundleReference = orderBundle.orders[0].product.productGroupSize.productGroup.reference

  const isMultiProductMembershipType = multiProductReferences.includes(orderBundleReference)

  if (isMultiProductMembershipType) {
    // Product that is used to store the images under on S3
    const productsUsedForImages = [Orientations.womenhipster]
    const productName = orderBundle.orders.find(order => productsUsedForImages.includes(order.product.productGroupSize.productGroup.reference)).product.name.toLowerCase()

    // Default Women Membership
    return getImagePaths({ path: `/images/design-women/${productName}/products/${productName}-women-set`, s3: true, noMobile: true })
  }

  const productName = orderBundle.orders[0].product.name.toLowerCase()

  if (orderBundleReference === Orientations.menone) {
    return getImagePaths({ path: `/images/design/${productName}/products/${productName}-men-one-boxershort`, s3: true, noMobile: true })
  }

  if (orderBundleReference === Orientations.boysoriginals) {
    return getImagePaths({ path: `/images/design/${productName}/products/${productName}-boys-originals-boxershort`, s3: true, noMobile: true })
  }

  if (orderBundleReference === Orientations.socksoriginals) {
    return getImagePaths({ path: `/images/design/${productName}/products/${productName}-originals-socks-regular`, s3: true, noMobile: true })
  }

  if (orderBundleReference === Orientations.sneakersocksoriginals) {
    return getImagePaths({ path: `/images/design/${productName}/products/${productName}-originals-socks-sneaker`, s3: true, noMobile: true })
  }

  // Default Men Originals Membership
  return getImagePaths({ path: `/images/design/${productName}/products/${productName}-men-originals-boxershort`, s3: true, noMobile: true })
}
